export async function fetchWithAuth(url, options = {}) {
    const token = localStorage.getItem('accessToken'); // Fetch JWT token from storage

    if (!token) {
        if (window.location.pathname !== '/') {
            console.error('Unauthorized! Redirecting to homepage...');
            window.location.href = '/';
        } else {
            console.error('Unauthorized! Already on homepage.');
        }
        throw new Error('Unauthorized'); // Prevent further processing
    }

    if (isTokenExpired(token)) {
        console.log("Token has expired, clearing and returning to login...");
        // Clear the stale token so the reload doesn't hit this branch again —
        // otherwise callers that run on every mount (e.g. GameConfig.fetchRooms)
        // reload '/' → mount → expired → reload → infinite loop on the login screen.
        localStorage.removeItem('accessToken');
        if (window.location.pathname !== '/') {
            window.location.href = '/';
        }
        throw new Error('Token expired');
    }
    // Add Authorization header with Bearer token. A FormData body (photo upload) must NOT get
    // the JSON Content-Type: the browser has to set multipart/form-data with its own boundary.
    const defaultHeaders = { 'Authorization': `Bearer ${token}` };
    if (!(options.body instanceof FormData)) {
        defaultHeaders['Content-Type'] = 'application/json'; // Default Content-Type
    }

    // Merge headers and other options passed into fetch
    const finalOptions = {
        ...options,
        headers: {
            ...defaultHeaders,
            ...options.headers, // Allow overriding specific headers
        },
        credentials: 'include', // include cookies
    };

    try {
        // Perform fetch with the given URL and merged options
        const response = await fetch(`${url}`, finalOptions);

        // Handle unauthorized status (401): redirect to login or homepage if needed
        if (response.status === 401) {
            console.error('Unauthorized! Clearing token, returning to login...');
            localStorage.removeItem('accessToken');
            if (window.location.pathname !== '/') {
                window.location.href = '/';
            }
            throw new Error('Unauthorized'); // Prevent further processing
        }

        // Check for HTTP errors
        if (!response.ok) {
            const message = await response.text(); // Get response body (if available)
            throw new Error(`HTTP Error: ${response.status} - ${message}`);
        }

        return response; // Return the response for further processing
    } catch (error) {
        console.error('Fetch error: ', error.message);
        throw error; // Throw the error further if needed in the caller
    }
}
function isTokenExpired(token) {
    try {
        const payload = JSON.parse(atob(token.split(".")[1])); // Decode the token payload
        const currentTime = Math.floor(new Date().getTime() / 1000); // Current time in seconds
        return payload.exp < currentTime;
    } catch {
        // A malformed/garbage token (stale cookie, corrupted storage) can't be
        // decoded — treat it as expired so it gets cleared instead of throwing.
        return true;
    }
}
export const addToken = (url) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
        return `${url}&token=${token}`;
    }
    return url;
};